/**
 * Speech Therapy Supervisory Visit Note — options + empty payload.
 * After shared common header (1–6): Visit Info → CMS Requirements →
 * Clinical Assessment → Plan of Care Review → Communication
 * (per ST Supervisory Visit screenshots).
 */

import { emptyStCommonHeader } from "./stNotesCommonHeaderUtils";

export const YES_NO_OPTIONS = ["Yes", "No"];

/** Type of Supervisory Visit — select one. */
export const SUPERVISORY_VISIT_TYPE_OPTIONS = [
  "Routine (Per Plan of Care)",
  "Resumption of Care",
  "Recertification",
  "Significant Change in Condition",
  "OASIS Follow-up",
  "Other",
];

export const VISIT_LOCATION_OPTIONS = [
  "Patient Home",
  "Assisted Living Facility",
  "Nursing Facility",
  "Other",
];

export const PARTICIPANT_OPTIONS = [
  "Supervising ST",
  "Patient",
  "Caregiver/Family",
  "Other Staff",
];

/** CMS 42 CFR §484.80 supervisory visit requirements (exact checklist). */
export const REQUIREMENTS_CHECKLIST_OPTIONS = [
  "Assessed patient's condition and any changes since last visit",
  "Assessed the patient's progress toward goals/outcomes",
  "Evaluated the appropriateness and effectiveness of the care provided",
  "Determined if the Plan of Care remains appropriate",
  "Reviewed all medications and any medication changes",
  "Evaluated patient/caregiver understanding of the plan of care",
  "Assessed safety of the environment",
  "Verified that services are being provided as ordered",
  "Addressed any problems or issues and revised plan as needed",
  "Communicated findings with the patient, caregiver, and care team",
];

export const COMMUNICATION_STATUS_OPTIONS = [
  "Improved",
  "Maintained",
  "Declined",
];

export const SWALLOWING_STATUS_OPTIONS = ["Safe", "At Risk", "Unsafe"];

export const COGNITIVE_LINGUISTIC_OPTIONS = [
  "At Baseline",
  "Improved",
  "Declined",
];

export const COMPENSATORY_STRATEGY_OPTIONS = [
  "Independent",
  "Needs Assistance",
  "Unable",
];

export const COMMUNICATION_WITH_OPTIONS = [
  "Patient",
  "Caregiver/Family",
  "Physician",
  "Other Staff",
];

export const COMMUNICATION_METHOD_OPTIONS = [
  "In Person",
  "Phone",
  "Electronic",
  "Other",
];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const coerceExclusiveChoice = (value) => {
  if (Array.isArray(value)) return value.find(Boolean) || "";
  return value == null ? "" : String(value);
};

export const today = () => new Date().toISOString().slice(0, 10);

/** Full editable ST Supervisory Visit payload (JSON on dedicated row). */
export const emptyStSupVisitPayload = () => ({
  billingCode: "G0153",
  timeIn: "",
  timeOut: "",

  visitDate: "",
  commonHeader: emptyStCommonHeader(),

  // —— 7. Visit Information ——
  supervisoryVisitType: "",
  supervisoryVisitTypeOther: "",
  visitLocation: "",
  visitLocationOther: "",
  participants: [],
  participantsOther: "",

  // —— 8. Supervisory Visit Requirements (CMS) ——
  requirementsChecklist: [],

  // —— 9. Clinical Assessment ——
  communicationStatus: "",
  communicationComments: "",
  swallowingStatus: "",
  dietRestrictions: "",
  cognitiveLinguisticStatus: "",
  cognitiveComments: "",
  compensatoryStrategies: "",
  compensatoryNotes: "",

  // —— 10. Plan of Care Review ——
  planOfCareReviewed: "",
  followUpRequired: "",
  followUpSpecify: "",
  planRemainsAppropriate: "",
  planRevisions: "",

  // —— 11. Communication ——
  communicationWith: [],
  communicationMethod: [],
  communicationMethodOther: "",
  communicationSummary: "",
});

export const ST_SUP_ARRAY_KEYS = [
  "participants",
  "requirementsChecklist",
  "communicationWith",
  "communicationMethod",
];
